<app-dropdown-menu class="level-selection"
    *ngIf="isDropdownVisible"
    (activeSelection)="changeActiveSelection($event)"
    [dropdownType]="LEVEL_SELECTION_DROPDOWN"
    [features]="levels"
    [isDropdownActive]="isDropdownActive"
    [hintFn]="getHint.bind(this)"
></app-dropdown-menu>
